import { Contacts as ContactsApp } from '@datapad/contacts';
import { assertNotUndefined } from '@datapad/utilities';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { DatapadAppStateContext } from '../../../utilities';
import { AppId } from '../AppId';

/**
 * Contacts app wrapper.
 *
 * @remarks
 * Handles URL parameter management for contact selection.
 * URL format: `/contacts?id=<character-id>`
 */
export function Contacts(): React.ReactElement {
	const location = useLocation();

	const { changeAppSelection } = assertNotUndefined(React.useContext(DatapadAppStateContext));

	// Parse URL for initial selection
	const searchParams = new URLSearchParams(location.search);
	const initialId = searchParams.get('id') ?? undefined;

	// Handle selection changes by updating URL
	const handleSelectionChange = React.useCallback(
		(contactId: string | undefined) => {
			const search = contactId ? `id=${contactId}` : '';
			// Use changeAppSelection to update URL (which uses history.push)
			changeAppSelection(AppId.Contacts, search, undefined);
		},
		[changeAppSelection],
	);

	return <ContactsApp initialSelectedId={initialId} onSelectionChange={handleSelectionChange} />;
}
